import React, { useEffect, useState } from "react";

export default function GetPastDrafts() {
  const [savedDrafts, setSavedDrafts] = useState([]);
  const [selectedDraftId, setSelectedDraftId] = useState("");
  const [draftedCards, setDraftedCards] = useState([]);
  const [hotCards, setHotCards] = useState([]);
  const [started, setStarted] = useState(false);
  const [loadedDraft, setLoadedDraft] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [expandedUsers, setExpandedUsers] = useState({});

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}api/draft/saved`)
      .then((res) => res.json())
      .then(setSavedDrafts)
      .catch((err) => console.error("Error fetching saved drafts:", err));
  }, []);

  const loadDraft = async () => {
    if (!selectedDraftId) {
      alert("Select a draft to load");
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}api/draft/load/${selectedDraftId}`
      );
      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Failed to load draft");
        return;
      }

      let hotCardArray = [];
      if (Array.isArray(data.hotCards) && data.hotCards.length > 0) {
        hotCardArray = data.hotCards.slice(0, 3);
      } else if (Array.isArray(data.draft.hotcardids)) {
        try {
          const cardRes = await fetch(
            `${process.env.REACT_APP_API_URL}api/data/snapCards/batch`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ ids: data.draft.hotcardids }),
            }
          );
          hotCardArray = await cardRes.json();
        } catch (err) {
          console.error("Error fetching hot card details:", err);
        }
      }

      setHotCards(hotCardArray);
      setDraftedCards(Array.isArray(data.picks) ? data.picks : []);
      setLoadedDraft(true);
      setStarted(false);
    } catch (err) {
      console.error("Error loading draft:", err);
    }
  };

  const toggleUserDropdown = (username) => {
    setExpandedUsers((prev) => ({
      ...prev,
      [username]: !prev[username],
    }));
  };

  const handleCardClick = (card) => {
    setSelectedCard((prev) =>
      prev?.cardId === (card.cardId || card.cardid) ? null : card
    );
  };

  const draftedByUser = draftedCards.reduce((acc, pick) => {
    if (!acc[pick.username]) acc[pick.username] = [];
    acc[pick.username].push(pick);
    return acc;
  }, {});

  return (
    <div className="drafts-panel">
      <div className="drafts-header">
        <div className="drafts-controls">
          <select
            value={selectedDraftId}
            onChange={(e) => setSelectedDraftId(e.target.value)}
            className="modern-select"
          >
            <option value="">Select a Saved Draft</option>
            {savedDrafts.map((d) => (
              <option key={d.id} value={d.id}>
                {d.draftname} (
                {d.createdat
                  ? new Date(d.createdat).toLocaleDateString("en-US")
                  : "No date"}
                )
              </option>
            ))}
          </select>
          <button className="modern-btn" onClick={loadDraft}>
            Load
          </button>
        </div>
      </div>

      {loadedDraft && !started && (
        <div className="results-container">
          <h2 className="results-heading">Draft Results</h2>
          {Object.entries(draftedByUser).map(([username, picks]) => (
            <div key={username} className="user-block">
              <div
                className="user-header"
                onClick={() => toggleUserDropdown(username)}
              >
                <span>{expandedUsers[username] ? "▼" : "▶"}</span>
                <h3>{username}</h3>
              </div>

              {expandedUsers[username] && (
                <div className="card-grid-modern">
                  {picks.map((pick) => (
                    <div
                      key={pick.cardid || pick.cardId}
                      className="draft-card-modern"
                      onClick={() => handleCardClick(pick)}
                    >
                      <img
                        src={pick.cardhtml || pick.cardHTML}
                        alt={pick.cardname || pick.cardName}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {selectedCard && (
        <div className="modern-modal" onClick={() => setSelectedCard(null)}>
          <div
            className="modern-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close-btn"
              onClick={() => setSelectedCard(null)}
            >
              ✖
            </button>
            <img
              src={selectedCard.cardhtml || selectedCard.cardHTML}
              alt={selectedCard.cardname || selectedCard.cardName}
              className="modal-image"
            />
            <div className="modal-info">
              <div>
                <strong>Cost</strong>:{" "}
                {selectedCard.cardcost || selectedCard.cardCost}
              </div>
              <div>
                <strong>Power</strong>:{" "}
                {selectedCard.cardpower || selectedCard.cardPower}
              </div>
            </div>
            <p className="modal-description">
              {selectedCard.carddesc || selectedCard.cardDesc}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
